/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/282-next': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z"/><path pid="1" d="M9 8L5 5v6zM11 5H9v6h2V5z"/>'
  }
})
